module.exports = __webpack_public_path__ + "static/jonathan-agoot-machine-learning-dynamically-assembled-ads-46e6b73f9e1e643c9ded2a0129dc5571.jpg";